import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import injectSheet from 'react-jss';

class DropdownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
        };
    }

    onMenuItemClick = event => {
        const index = Array.from(event.target.parentElement.children).indexOf(
            event.target,
        );
        const action = this.props.actions[index];
        this.onClose();
        this.props.onClick(action);
    };

    onClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    onClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { anchorEl } = this.state;
        const { actions, classes } = this.props;

        const menuItems = actions.map(action => (
            <MenuItem key={action} onClick={this.onMenuItemClick}>
                {action}
            </MenuItem>
        ));
        return (
            <React.Fragment>
                <IconButton onClick={this.onClick}>
                    <i className="material-icons">more_vert</i>
                </IconButton>
                <Menu
                    className={classes.menu}
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={this.onClose}
                >
                    {menuItems}
                </Menu>
            </React.Fragment>
        );
    }
}

DropdownMenu.propTypes = {
    onClick: PropTypes.func.isRequired,
    actions: PropTypes.array.isRequired,
};

const style = ({ palette, spacing, overrides }) => ({
    menu: {
        '& ul': {
            padding: 0,
        },
    },
});

export default injectSheet(style)(DropdownMenu);



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.js